import styles from './AppSelector.module.css';

const AppSelector = ({ onSelect, recommendedPaths = [] }) => {
  console.log(recommendedPaths, 'recommendedPaths');
  return (
    <div className={styles.appSelectorContainer}>
      <h1 className={styles.title}>Choose Your Learning Path</h1>
      
      {/* {recommendedPaths.length > 0 && (
        <div className={styles.recommendation}>
          <p>Based on our assessment, we recommend improvements to  
            <strong>{" " +recommendedPaths.join(', ')}</strong>
          </p>
        </div>
      )} */}
      
      <div className={styles.appGrid}>
        <div 
          className={`${styles.appCard}`}
          onClick={() => onSelect('grammar')}
        >
          <div className={styles.appIcon}>📝</div>
          <h2 className={styles.appTitle}>Grammarly</h2>
          <p className={styles.appDescription}>
            Perfect your grammar skills with interactive exercises, story-based learning, and adaptive challenges.
          </p>
          <ul className={styles.featureList}>
            <li>Sentence correction</li>
            <li>Grammar construction</li>
            <li>Story-based learning</li>
            <li>Adaptive exercises</li>
          </ul>
        </div>

        <div 
          className={`${styles.appCard} `}
          onClick={() => onSelect('writing')}
        >
          <div className={styles.appIcon}>✍️</div>
          <h2 className={styles.appTitle}>Writely</h2>
          <p className={styles.appDescription}>
            Improve your writing skills with guided exercises.
          </p>
          <ul className={styles.featureList}>
            <li>Sentence Correction</li>
            <li>Story Correction</li>
            <li>Creative Writing</li>
            <li>Persuasive Writing</li>
          </ul>
        </div>

        <div 
          className={`${styles.appCard}`}
          onClick={() => onSelect('spelling')}
        >
          <div className={styles.appIcon}>📚</div>
          <h2 className={styles.appTitle}>Spelling Pro</h2>
          <p className={styles.appDescription}>
            Master spelling through engaging activities, audio challenges, and interactive word games.
          </p>
          <ul className={styles.featureList}>
            <li>Word completion</li>
            <li>Audio spelling</li>
            <li>Anagram challenges</li>
            <li>Spelling bee</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AppSelector; 